"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = require("./context");
/****************************************************************
 * Hooks
 ****************************************************************/
exports.useFeatureFlag = function (flagName) {
    var featureFlags = react_1.useContext(context_1.FlaggContext).featureFlags;
    return [
        featureFlags.get(flagName),
        function (value) { return featureFlags.set(flagName, value); }
    ];
};
//# sourceMappingURL=hooks.js.map